export const DESC = "desc";
export const ASC = "asc";
export type ISortDirection = typeof DESC | typeof ASC;

export interface IOrderBy<T = string> {
    field: T;
    sortDirection: ISortDirection;
}

export const tableSorter = (orderBy: IOrderBy) => (rowA: FixmeType, rowB: FixmeType) => {
    const { sortDirection, field } = orderBy;
    if (rowA[field] > rowB[field]) {
        return sortDirection === "desc" ? -1 : 1;
    }
    return sortDirection === "desc" ? 1 : -1;
};
